import styled from 'styled-components';
import { theme, toRem } from 'design';
import ModalFooter from './ModalFooter';

export const ModalForm = styled.form`
  position: relative;
  width: 100%;

  ${ModalFooter} {
    padding-top: ${toRem(theme.space['3xl'])};
  }
`;

interface IModalFormLayoutProps {
  compact?: boolean;
  disabled?: boolean;
}

export const ModalFormLayout = styled.div<IModalFormLayoutProps>`
  display: grid;
  grid-template-columns: 1fr;
  grid-gap: ${({ compact }) => (compact ? toRem(theme.space.sm) : toRem(theme.space.xl))};
  width: 100%;
  height: auto;
  padding: ${toRem(theme.space.xl)};
  border-radius: ${toRem(11)};
  background-color: ${({ disabled }) => (!disabled ? theme.color.neutral[100] : theme.color.neutral[25])};
  justify-items: center;

  > * {
    margin-bottom: 0 !important;
  }
`;
